var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-public"},[_c('the-public-content',{staticClass:"l-public__content"},[_vm._t("default")],2),_vm._v(" "),_c('the-public-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }